export default function RoundSetup({
  details,
  isLocked,
  onChange,
}) {
  const fields = [
    ["tournament", "Tournament", "e.g. Glenbrooks Invitational"],
    ["roundNumber", "Round", "e.g. 3"],
    ["proTeam", "Pro team", "Team name"],
    ["conTeam", "Con team", "Team name"],
  ];

  return (
    <section
      className="setup-grid section-reveal"
      aria-label="Round setup"
      data-testid="round-setup-section"
    >
      <div className="resolution-field">
        <label htmlFor="resolution">Resolution</label>
        <div className="resolution-input-row">
          <input
            id="resolution"
            disabled={isLocked}
            value={details.resolution}
            onChange={(event) => onChange("resolution", event.target.value)}
            placeholder="Resolved: The United States federal government should..."
            data-testid="resolution-input"
          />
        </div>
      </div>
      {fields.map(([key, label, placeholder]) => (
        <div className="compact-field" key={key}>
          <label htmlFor={key}>{label}</label>
          <input
            id={key}
            disabled={isLocked}
            value={details[key]}
            onChange={(event) => onChange(key, event.target.value)}
            placeholder={placeholder}
            data-testid={`${key}-input`}
          />
        </div>
      ))}
      {isLocked && (
        <p className="round-lock-notice" data-testid="round-setup-locked-notice">
          Round setup is locked while the timer is in use.
        </p>
      )}
    </section>
  );
}
